const MESES = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez']

const nf = (min: number, max = min) =>
    new Intl.NumberFormat('pt-BR', { minimumFractionDigits: min, maximumFractionDigits: max })

const INTEIRO = nf(0)
const DECIMAL_1 = nf(1)
const DECIMAL_2 = nf(2)

const vazio = (v: number | null | undefined): v is null | undefined => v === null || v === undefined || Number.isNaN(v)

export function formatCompetencia(data: string | null | undefined) {
    if (!data) return ''
    const [ano, mes] = data.split('-')
    return `${MESES[Number(mes) - 1] ?? mes}/${ano}`
}

export function formatData(data: string | null | undefined) {
    if (!data) return ''
    const [ano, mes, dia] = data.slice(0, 10).split('-')
    return `${dia}/${mes}/${ano}`
}

export function formatTrimestre(data: string | null | undefined) {
    if (!data) return ''
    const [ano, mes] = data.split('-').map(Number)
    return `${Math.floor((mes - 1) / 3) + 1}º Trim. de ${ano}`
}

export function formatTrimestreCurto(data: string) {
    const [ano, mes] = data.split('-').map(Number)
    return `${Math.floor((mes - 1) / 3) + 1}T${String(ano).slice(2)}`
}

export function formatInteiro(v: number | null | undefined) {
    return vazio(v) ? '' : INTEIRO.format(v)
}

export function formatDecimal1(v: number | null | undefined) {
    return vazio(v) ? '' : DECIMAL_1.format(v)
}

export function formatPercentual(v: number | null | undefined, casas = 1) {
    return vazio(v) ? '' : `${nf(casas).format(v * 100)} %`
}

export function formatMoeda(v: number | null | undefined) {
    if (vazio(v)) return ''
    return v < 0 ? `-R$ ${DECIMAL_2.format(-v)}` : `R$ ${DECIMAL_2.format(v)}`
}

export function formatCompacto(v: number | null | undefined, casas?: number) {
    if (vazio(v)) return ''
    const abs = Math.abs(v)
    const escala: [number, string][] = [
        [1e9, ' Bi'],
        [1e6, ' Mi'],
        [1e3, ' Mil']
    ]
    for (const [base, sufixo] of escala) {
        if (abs >= base) {
            const n = v / base
            const c = casas ?? (Math.abs(n) >= 100 ? 0 : 1)
            return `${nf(0, c).format(n)}${sufixo}`
        }
    }
    return nf(0, casas ?? 1).format(v)
}
